const bikeOverviewRouter = {
  path: 'bike-overview',
  name: 'Bike Overview',
  component: () => import('@/views/service-tools/bike-overview/Index.vue'),
  redirect: '/service-tools/bike-overview',
  meta: { title: 'bikeOverview', icon: '' },
  children: [
    {
      path: '',
      name: '',
      component: () =>
        import('@/views/service-tools/bike-overview/BikeInfomation.vue'),
      meta: { title: 'bikeOverview', icon: '' }
    },
    {
      path: 'register/recheck',
      name: 'Register Recheck',
      component: () => import('@/views/service-tools/bike-overview/register/RegisterRecheck.vue'),
      meta: { title: 'registerRecheck', icon: 'fa-bicycle', auth: true },
      hidden: true
    }
  ]
};

export default bikeOverviewRouter;
